function getAnchorUrlFromEvent(event) {
    const hrefValue = getAnchorUrl(event.target);
    if (!isValidUrl(hrefValue)) return null;

    return hrefValue;
}

function isValidUrl(urlString) {
    if (!urlString) {
        return false;
    }

    /**
     * We check if some common origin urls used in the reader are owners avoiding redirect to incorrect address.
     * We're using urls like https://felini.publica.la or https://volpe.publica.la for moving us in the TOC of content.
     * If we don't exclude them, the correct redirect using TOC in the content will broken.
     * For this reason, we're excluding all origin that contain `felini` or `volpe` values using a regex.
     * Fenice uses `https://appassets.androidplatform.net`, `file://`, `http://localhost`* or `http://127.0.0.1`*
     * to host Volpe, so we also take that one into account. * Are deprecated in versions 1.26.7 and higher.
     * As we're matching on the url origin, we don't need to worry
     * that much about these words being present in the URL.
     */
    const url = new URL(urlString);
    if (url.protocol === 'file:') {
        return false;
    }
    if (url.origin.match(/felini|volpe|localhost|127.0.0.1|appassets.androidplatform.net/gi)) {
        return false;
    }

    try {
        return Boolean(url);
    } catch (_error) {
        return false;
    }
}

function getAnchorUrl(target) {
    const tag = 'A';
    let node = target;
    let levelsChecked = 0;

    /*
     * We are only checking 3 levels (target, parent, and grandparent)
     * to ensure we properly find the anchor (<a>) element.
     */
    while (node && levelsChecked < 3) {
        if (node.tagName?.toUpperCase() === tag) {
            return node.href;
        }

        node = node.parentNode;
        levelsChecked++;
    }

    return null;
}

export { getAnchorUrlFromEvent };
